module.exports = __webpack_public_path__ + "img/l2.5f4c278e.png";